import type { GameConfigType } from '@/pages/dashboard/types/dashboard';

// customFilterList 存储项目中后端传递的自定义筛选器的key，用于判断筛选器是否是自定义筛选器
let customFilterList: string[] = [];

/**
 * 从 gameConfig 的 default_selector / page_selector 中收集 is_custom === 1 的筛选器 key
 * 用于与 new_selector 的 custom_filters 合并，得到完整的「自定义筛选器」列表
 */
export function getCustomFilterKeysFromConfig(
  gameConfig: GameConfigType | null
): string[] {
  if (!gameConfig) return [];
  const keys: string[] = [];
  const collect = (filters: { key: string; is_custom?: '0' | '1' }[] | undefined) => {
    filters?.forEach((f) => {
      if (f?.is_custom === '1') keys.push(f.key);
    });
  };
  gameConfig.default_selector?.forEach((s) => collect(s.filters));
  gameConfig.page_selector?.forEach((s) => collect(s.filters));
  return [...new Set(keys)];
}

// 设置自定义筛选器列表：追加逻辑
export const setCustomFilterList = (list: string[], cover = false) => {
  if (cover) {
    customFilterList = list || [];
    return;
  } 
  if (list) {
    // 合并两个数组
    const combinedList = customFilterList.concat(list);
    // 使用Set去除重复项
    const uniqueFilterList = Array.from(new Set(combinedList));
    // 返回去重后的数组
    customFilterList = uniqueFilterList;
  } else {
    customFilterList = customFilterList;
  }
  
 
};

// 获取自定义筛选器列表
export const getCustomFilterList = () => customFilterList;

// 重置自定义筛选器列表，是否可删除该方法，因为自定义筛选器是整个系统通用的，不区分业务
export const resetCustomFilterList = () => {
  customFilterList  = [];
};